import { BaseComponent } from '../base-component.js';
import { resolveImageUrl } from '../../shared/utils.js';
import componentStyles from './featured-block.css?inline';

export class FeaturedBlock extends BaseComponent {
  private blockTitle = '';
  private description = '';
  private imageUrl = '';

  static get observedAttributes(): string[] {
    return ['title', 'description', 'image-url'];
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string): void {
    switch (name) {
      case 'title':
        this.blockTitle = newValue || '';
        break;
      case 'description':
        this.description = newValue || '';
        break;
      case 'image-url':
        this.imageUrl = newValue || '';
        break;
    }
    if (this.isConnected) {
      this.render();
    }
  }

  protected styles(): string {
    return componentStyles;
  }

  protected template(): string {
    return '';
  }

  protected render(): void {
    const container = this.shadow.querySelector('.featured-block-container');
    if (container) {
      container.remove();
    }

    const containerDiv = document.createElement('div');
    containerDiv.className = 'featured-block-container';

    const contentDiv = document.createElement('div');
    contentDiv.className = 'featured-content';

    const titleElement = document.createElement('h2');
    titleElement.className = 'featured-title';
    titleElement.textContent = this.blockTitle;
    contentDiv.appendChild(titleElement);

    const descriptionElement = document.createElement('p');
    descriptionElement.className = 'featured-description';
    descriptionElement.textContent = this.description;
    contentDiv.appendChild(descriptionElement);

    containerDiv.appendChild(contentDiv);

    if (this.imageUrl) {
      const sanitizedUrl = resolveImageUrl(this.imageUrl);
      if (sanitizedUrl) {
        const imageDiv = document.createElement('div');
        imageDiv.className = 'featured-image';

        const img = document.createElement('img');
        img.src = sanitizedUrl;
        img.alt = this.blockTitle;

        imageDiv.appendChild(img);
        containerDiv.appendChild(imageDiv);
      }
    }

    this.shadow.appendChild(containerDiv);
  }
}

customElements.define('featured-block', FeaturedBlock);
